// import React, { useEffect, useState } from 'react';
// import Typography from '@material-ui/core/Typography';
// import SkeletonBody from '@afosto/components-react/SkeletonBody';
// import fetchProduct from '../../fetchProduct';
import React from 'react';
import PropTypes from 'prop-types';
import MuiLink from '@material-ui/core/Link';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const PRODUCTS_APP_ORIGIN = BASE_URL.replace('{app}', 'products');

const ProductSkuFormatter = ({ sku }) => (
  // const [product, setProduct] = useState(null);
  // const [isLoading, setIsLoading] = useState(false);
  //
  // useEffect(() => {
  //   let isMounted = true;
  //
  //   const fetchProductInformation = async () => {
  //     setIsLoading(true);
  //
  //     try {
  //       const productInformation = await fetchProduct(sku);
  //
  //       if (isMounted) {
  //         setProduct(productInformation);
  //       }
  //     } catch (err) {
  //       if (isMounted) {
  //         setProduct([]);
  //       }
  //     } finally {
  //       if (isMounted) {
  //         setIsLoading(false);
  //       }
  //     }
  //   };
  //
  //   if (sku && isMounted) {
  //     fetchProductInformation();
  //   }
  //
  //   return () => {
  //     isMounted = false;
  //   };
  // }, [sku]);
  //
  // if (isLoading) {
  //   return <SkeletonBody lines={1} />;
  // }
  //
  // if (!product) {
  //   return <Typography variant="subtitle1">{sku || '-'}</Typography>;
  // }

  <MuiLink variant="subtitle1" href={`${PRODUCTS_APP_ORIGIN}/products/${encodeURIComponent(sku)}`}>
    {sku || '-'}
  </MuiLink>
);
ProductSkuFormatter.propTypes = {
  sku: PropTypes.string,
};

ProductSkuFormatter.defaultProps = {
  sku: undefined,
};

export default ProductSkuFormatter;
